import React, { Component } from 'react'
import VideoPlayer from "../Helper/VideoPlayer"
import arrowUpDown from '../../assets/images/icons/arrow-up-down.png'

export default class SkewHit extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div>
          <div className="mt-3">
              <div className="row">
              <div className="col-lg-5">
                    <VideoPlayer src="https://www.youtube.com/embed/BX6jY97D1wM" thumbnail="Test-Skew-16.jpg" width="300"/>
                </div>
                <div className="col-lg-6">
                <p>Now that you've found some side-to-side eye movements, we'll perform the
                  {/* eslint-disable-next-line  */}
                  <a className="text-decoration"> Test of Skew</a> to check for up-and-down movements.</p>
                  <p>
                  We are looking for any slight vertical correction, meaning that the eyes will move up or down.
                  </p>
                  <p>
                  View the video and perform the test as shown. 
                  </p>
                  <p>It will show you what types of eye movement to look for</p>
                  <p>What kind of eye movements did you notice?</p>
                </div>
                
              </div>
              
              <div className="row ">
                <div className="col-lg-4">
                   <button className="btn btn-dark w-100 p-2H text-left"  onClick={onClick.bind(this,17,true)}>
                     <div className="float-left">Up &amp; Down</div>
                     <img  className="float-right" alt="arrow-up-down" src={arrowUpDown} width="45"/>
                     </button>
                </div>
               
                <div className="col-lg-4">
                  <button className="btn btn-dark w-100 p-2H text-left"  onClick={onClick.bind(this,15,false)}>
                    <div className="float-left">None</div>
                    <i className="fa fa-ban float-right t-30"></i>
                  </button>
                </div>
              
              </div>
          </div>
         
        </div>

    )
  }
}
